import { Gem, CalendarHeart, MessageCircle } from "lucide-react";
import { DORIE_URL, WHATSAPP_URL } from "../constants";
import { Reveal } from "./Reveal";

const PACKAGES = [
    {
        name: "تقشير كوزموبيل للجسم",
        desc: "علاج تقشير للجسم، ويتضمن الكريمات المرافقة للعلاج.",
        priceLabel: "السعر",
        price: "1,500 ₪",
        img: "https://images.pexels.com/photos/7020265/pexels-photo-7020265.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
        name: "باقة البيروسترابيا",
        desc: "10 جلسات على جهاز البيروسترابيا.",
        priceLabel: "سعر الباقة",
        price: "1,000 ₪",
        img: "/pressotherapy.jpg",
    },
    {
        name: "باقة EMS",
        desc: "10 جلسات على جهاز EMS.",
        priceLabel: "سعر الباقة",
        price: "1,000 ₪",
        img: "/ems-bed.jpg",
    },
    {
        name: "باقة الإبر التجميلية",
        desc: "10 جلسات من الإبر التجميلية.",
        priceLabel: "سعر الباقة",
        price: "1,000 ₪",
        img: "https://images.pexels.com/photos/8313237/pexels-photo-8313237.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
];

export const Packages = () => (
    <section
        id="packages"
        data-testid="packages-section"
        className="scroll-mt-24 py-20 lg:py-28 bg-white"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <Reveal className="max-w-2xl">
                <p className="mb-3 text-sm font-bold text-miam-rose">
                    عناية أعمق
                </p>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-miam-dark">
                    الباقات والعلاجات{" "}
                    <span className="italic text-miam-rose">المتقدمة</span>
                </h2>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {PACKAGES.map(({ name, desc, priceLabel, price, img }, i) => (
                    <Reveal key={name} delay={0.05 * (i % 4)}>
                        <article
                            data-testid={`package-card-${i}`}
                            className="group relative flex h-full flex-col overflow-hidden rounded-3xl bg-miam-cream p-8 soft-shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5"
                        >
                            <span
                                className="absolute -top-8 -left-8 h-24 w-24 rounded-full bg-miam-rose/15"
                                aria-hidden="true"
                            />
                            <img
                                src={img}
                                alt=""
                                aria-hidden="true"
                                loading="lazy"
                                className="pointer-events-none absolute inset-0 h-full w-full scale-105 object-cover opacity-0 transition-[opacity,transform] duration-700 ease-out group-hover:scale-100 group-hover:opacity-100"
                            />
                            <div
                                className="pointer-events-none absolute inset-0 bg-gradient-to-t from-miam-dark/90 via-miam-dark/65 to-miam-dark/30 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                                aria-hidden="true"
                            />

                            <div className="relative flex h-full flex-col">
                                <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-miam-rose/15 text-miam-rose transition-[background-color,color] duration-300 group-hover:bg-white/20 group-hover:text-white">
                                    <Gem className="h-6 w-6" aria-hidden="true" />
                                </span>
                                <h3 className="font-heading text-lg font-bold text-miam-dark transition-colors duration-300 group-hover:text-white">
                                    {name}
                                </h3>
                                <p className="mt-3 flex-1 text-sm text-miam-muted leading-relaxed transition-colors duration-300 group-hover:text-white/85">
                                    {desc}
                                </p>
                                <p className="mt-6 text-xs text-miam-muted transition-colors duration-300 group-hover:text-white/70">
                                    {priceLabel}
                                </p>
                                <p
                                    data-testid={`package-price-${i}`}
                                    className="font-heading text-3xl font-bold text-miam-rose transition-colors duration-300 group-hover:text-white"
                                >
                                    {price}
                                </p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1}>
                <div className="mt-12 rounded-3xl bg-miam-green/10 px-8 py-8 text-center">
                    <p
                        data-testid="packages-note"
                        className="text-base text-miam-dark font-medium"
                    >
                        للاستفسار عن ملاءمة العلاج أو الباقة، تواصلي مباشرة مع
                        مياسة عبر واتساب.
                    </p>
                    <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
                        <a
                            href={DORIE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="packages-booking-button"
                            className="inline-flex items-center gap-2 rounded-full bg-miam-green px-7 py-3.5 text-sm font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-miam-green-dark hover:shadow-lg"
                        >
                            <CalendarHeart className="h-4 w-4" aria-hidden="true" />
                            احجزي عبر دُوري
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="packages-whatsapp-button"
                            className="inline-flex items-center gap-2 rounded-full bg-miam-rose px-7 py-3.5 text-sm font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-miam-rose-dark hover:shadow-lg"
                        >
                            <MessageCircle className="h-4 w-4" aria-hidden="true" />
                            اسألي مياسة
                        </a>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
